
	import { startClient } from "rakkasjs";
	startClient();
